import { Injectable } from "@angular/core"
import { AppConfig } from "@service/app.config"
import { ToasterConfig, ToasterService } from "angular2-toaster"

@Injectable()
export class ToasterLibraryService {
  toasterconfig: ToasterConfig = new ToasterConfig({
    positionClass: AppConfig.toasterPositionClass,
    showCloseButton: AppConfig.toasterShowCloseButton,
  })

  private default: any = {
    error: {
      title: "Whoops. That didn't work.",
      description: "Please try again later.",
    },
    success: {
      title: "Success!",
      description: "",
    },
    warning: {
      title: "Warning!",
      description: "",
    },
    info: {
      title: "Information!",
      description: "",
    },
  }

  constructor(private toasterService: ToasterService) {}

  error(title: string = null, description: string = null) {
    console.error(
      "toaster-library error",
      "title",
      title,
      "description",
      description
    )
    title = title || this.default.error.title
    description = description || this.default.error.description
    this._popSimple("error", title, description)
  }

  success(title: string = null, description: string = null) {
    title = title || this.default.success.title
    description = description || this.default.success.description
    this._popSimple("success", title, description)
  }

  warning(title: string = null, description: string = null) {
    title = title || this.default.warning.title
    description = description || this.default.warning.description
    this._popSimple("warning", title, description)
  }

  info(title: string = null, description: string = null) {
    title = title || this.default.info.title
    description = description || this.default.info.description
    this._popSimple("info", title, description)
  }

  detailed(
    type: "error" | "success" | "warning" | "info",
    title: string,
    message: string,
    details: string
  ) {
    const toastTitle = title || this.default[type].title
    const shortMsg = message || this.default[type].description
    const longDetails = details || ""

    const htmlBody = `
      <div>
        <div>${this._escapeForHtml(shortMsg)}</div>
        <details style="margin-top: 0.5em; color: #333;">
          <summary style="color: #fff; cursor: pointer; font-weight: 600;">
            Show details ▼
          </summary>
          <div style="color: #fff; margin-top: 0.5em;">
            ${this._escapeForHtml(longDetails).replace(/\n/g, "<br/>")}
          </div>
        </details>
      </div>
    `

    this.toasterService.pop({
      type: type,
      title: toastTitle,
      body: htmlBody,
      timeout: 0,
      showCloseButton: true,
      bodyOutputType: 1,
      tapToDismiss: false,
    })
  }

  private _popSimple(type: any, title: string, body: string) {
    this.toasterService.pop(type, title, this._escapeForHtml(body))
  }

  private _escapeForHtml(input: string): string {
    if (!input || typeof input !== 'string') return ""
    return input
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }

  public getToasterConfig(): ToasterConfig {
    return this.toasterconfig
  }
}
